// extracted by mini-css-extract-plugin
export default {"Omne":"Omne_Omne__8sUiF","content":"Omne_content__1vUOR","podNadpisom":"Omne_podNadpisom__OUve-","podNadpisomVlavo":"Omne_podNadpisomVlavo__KOVzk"};